import { render, staticRenderFns } from "./form-attachment.vue?vue&type=template&id=135e5566"
import script from "./form-attachment.vue?vue&type=script&lang=js"
export * from "./form-attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports